const selects = document.querySelectorAll('.select')

selects.forEach(select => {
  const head = select.querySelector('.select-head')
  const options = select.querySelector('.select-options')
  const value = head.querySelector('.body-1')

  head.addEventListener('click', (e) => {
    e.stopPropagation()
    if (select.classList.contains('open')) {
      select.classList.remove('open')
    } else {
      selects.forEach(el => {
        el === select ? el.classList.add('open') : el.classList.remove('open')
      })
    }
  })

  options.addEventListener('click', (e) => {
    e.stopPropagation()
    if (e.target.dataset.optionValue) {
      value.textContent = e.target.textContent
      value.dataset.optionValue = e.target.dataset.optionValue
      select.classList.remove('open')
    }
  })
})

if (selects.length) {
  document.addEventListener('click', (e) => {
    if (e.target) {
      selects.forEach(select => select.classList.remove('open'))
    }
  })
}